export type ConstructionType = 'tradicional' | 'steel_frame' | 'wood_frame' | 'prefabricada';
export type Stage = 'anteproyecto' | 'proyecto' | 'obra';
export type State = 'pendiente' | 'aprobado' | 'rechazado';

export const CONSTRUCTION_TYPE_OPTIONS = [
  { value: 'tradicional', label: 'Tradicional' },
  { value: 'seca', label: 'En Seco' },
  { value: 'mixta', label: 'Mixta' }
];

export const STAGE_OPTIONS = [
  { value: 'anteproyecto', label: 'Anteproyecto' },
  { value: 'proyecto', label: 'Proyecto' },
  { value: 'obra', label: 'Obra' }
];

export const STATE_OPTIONS = [
  { value: 'pendiente', label: 'Pendiente' },
  { value: 'aprobado', label: 'Aprobado' },
  { value: 'rechazado', label: 'Rechazado' }
];

export const CURRENCY_OPTIONS = [
  { value: 'ARS', label: 'ARS ($)' },
  { value: 'USD', label: 'USD (US$)' }
];

export const DEFAULT_FORM_VALUES = {
  name: '',
  description: '',
  total_surface: 0,
  covered_surface: 0,
  semicovered_surface: 0,
  uncovered_surface: 0,
  environments: 0,
  bedrooms: 0,
  bathrooms: 0,
  floors: 0,
  garage: false,
  yard: false,
  terrace: false,
  pool: false,
  implantation: 0,
  construction_type: 'tradicional',
  stage: 'anteproyecto',
  state: 'pendiente',
  budget: 0,
  budget_currency: 'ARS',
  consultation_price: 0,
  consultation_price_currency: 'ARS',
  price: 0,
  price_currency: 'ARS',
  preliminary_project_subcategory_id: 0,
  user_id: 0,
  materiality_id: 0,
  use_id: 0,
  images: []
};

export const VALIDATION_RULES = {
  name: {
    required: true,
    minLength: 3,
    maxLength: 100
  },
  description: {
    required: true,
    minLength: 50,
    maxLength: 1000
  },
  budget: {
    min: 0
  },
  implantation: {
    min: 0,
    max: 999999
  }
};

